<template>
	<div class="modal fade" id="Modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel3" aria-hidden="true" v-on:click="toggleModalFlagSon">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" ></button>
				</div>
				<div class="modal-body">
					<div class="modal-pd-pic" v-bind:style="{backgroundImage: 'url(' + setImageUrlModal(votePageShowPd.image) + ')'}"></div>
					<div class="pd-info">
						<p class="pd-info-brand-name">{{ votePageShowPd.brand }}</p>
						<h2 class="pd-info-pd-name">{{ votePageShowPd.product }}</h2>
						<span class="pd-info-price">{{votePageShowPd.price}}</span>

						<!-- <span v-if="sendPage=='man' || sendPage=='asiatop10'"></span> -->
						<span v-if="votePageShowPd.capacity!=''" class="pd-info-capacity"> / {{ votePageShowPd.capacity}}</span>
						
						<p class="pd-info-detail">
						{{votePageShowPd.detail}}
						</p>

						<!-- check page and change shoe element -->
						<div v-if="checkPage(sendPage)" class="expert-comment-box">
							<div class="modal-expert-pic-box">
								<div class="pic" v-bind:style="{backgroundImage: 'url(' + setImageUrlModal(showExpert.photo) + ')'}"></div>
								<span class="expert-name">
									{{showExpert.expert}}
								</span>
							</div>
							<div class="modal-expert-comment">
								{{ showExpert.comment }}
							</div>
						</div>
						<div v-else class="check-vote">
							<a v-if="sendPage == 'vote'" class="vote-btn" v-on:click="sendVote()">投它一票</a>
							<a v-else class="man"></a>
						</div>
						
					</div>
				</div>
				<div class="modal-close-botton" data-dismiss="modal" aria-label="Close">
					關閉視窗
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: 'Modal',
  data () {
	return {
	  modalFlag: null,
	  voteFlag: false
	}
  },
  props:{
	  votePageShowPd: Object,
	  modalShownSon: Boolean,
	  imgUrl: String,
	  sendPage: String,
	  showExpert: Object
  },
  watch:{
	  modalShownSon(value){
		  let self = this 
		  self.modalFlag = value
		//   console.log("modal:"+self.modalFlag)
		  
	  },
  },
  created(){
	
  },
  methods:{
		setImageUrlModal: function(productImage){
				let self = this 
				return self.imgUrl+'images/'+productImage
		},
		toggleModalFlagSon: function(){
			let self = this 
			self.modalFlag = !self.modalFlag
			this.$parent.modalShown = self.modalFlag
		},
		checkPage: function(page){
			let self = this 
			// console.log("chexkPage:"+page)
			if(page == 'expert')
			{
				return true 
			}
			else
			{
				return false
			}

		},
		sendVote: function(){
			this.$emit('listenSendvote')
		}
  }
}

</script>
<style lang="sass" scope>
@mixin rwd($w)
	@media only screen and (max-width: $w) 
		@content
$main-color: #f21290

.modal
	background-color: rgba(0,0,0,0.5)

.modal-dialog
	margin: 0 auto
	margin-top: calc(50vh - 276.5px)
	width: 924px
	max-width: none
	height: 553px
	background-color: #fff
	border-style: solid
	border-width:  5px 
	border-image-source: linear-gradient(335deg, #03001e, #7303c0 29%, #ec38bc 49%, #7303c0)
	border-image-slice: 1
.modal-body
	padding: 0
	width: 100%
	height: 100%
.modal-header
	border-bottom: none
	padding: 0
.modal-content
	background-color: transparent
	border: none
	width: 100%
	height: 100%
.modal-dialog
	$close-size: 45px

	.close
		position: absolute
		right: 27px
		top: 27px
		z-index: 10
		height: $close-size
		width: $close-size
		padding: 0
		margin: 0
		color: #fff
		background-color: transparent
		background-image: url(../assets/images/modal-close.png)
		background-size: contain
		opacity: 1
		cursor: pointer
		transition: transform .6s
		outline: none
		&:hover
			transform: rotate(180deg)
.modal-body
	display: flex
	flex-direction: row
	justify-content: space-evenly
	align-items: center
	>.modal-pd-pic
		width: 425px
		height: 425px
		background-color: #dedede 
		background-position: 50% 50%
		background-repeat: no-repeat
		background-size: cover 
	.pd-info
		width: 358px
		height: 425px
		position: relative
		&-brand-name
			font-size: 18px
			font-weight: 300
			line-height: 1.55
		&-pd-name
			position: relative
			font-size: 32px
			font-weight: 500
			color: $main-color
			margin-bottom: 30px
			&:after 
				content: ''
				position: absolute
				bottom: -18px
				left: 0
				width: 100%
				height: 1px
				background-image: linear-gradient(to right, #03001e, #7303c0 29%, #ec38bc 49%, #7303c0)
		span
			line-height: 1.5
			letter-spacing: 0.4px
		&-detail
			font-size: 16px
			line-height: 1.5
			letter-spacing: 0.4px
			text-align: justify
		a 
			position: absolute
			bottom: 0

.modal-close-botton
	display: none

.vote-btn
	width: 166px
	height: 35px
	text-align: center
	font-size: 16px
	line-height: 35px
	font-weight: 300
	cursor: pointer
	color: #fff !important
	position: relative
	z-index: 2
	margin: 0 auto
	&:before
		font-family: FontAwesome
		content: "\f08a"
		text-align: right
		position: absolute
		padding-right: 30px
		top: 0
		left: 0
		width: 100%
		height: 100%
		background-color: $main-color
		transition: opacity .5s ease-in-out
		z-index: -1
	&:after 
		font-family: FontAwesome
		content: "\f004"
		text-align: right
		position: absolute
		padding-right: 30px
		top: 0
		left: 0
		width: 100%
		height: 100%
		z-index: -1
		transition: opacity .35s ease-in-out
		background-image: linear-gradient(to right, #e4007f, #ff2fc1 49%, #af1dd0)
		opacity: 0
	&:hover,
	&:active
		&:after 
			opacity: 1


.expert-comment-box
	width: 355px
	height: 142px
	background-color: #eeeeee
	display: flex
	flex-direction: row
	align-items: center
	position: absolute
	bottom: -30px
	padding: 20px 10px 25px
	>.modal-expert-pic-box
		.pic
			width: 95px
			height: 95px
			background-color: #959595
			border-radius: 50%
			background-size: cover 
			background-repeat: no-repeat
		span 	
			font-size: 12px
			font-weight: 300
			color: #333333
			display: block
			text-align: center
			padding-top: 5px

	>.modal-expert-comment
		padding-top: 3px
		padding-left: 4px
		font-size: 14px
		line-height: 1.43
		text-align: justify
		color: $main-color

+rwd(1000px)
	.modal-dialog
		width: 100%
	.modal-body 
		>.modal-pd-pic 
			width: 50%
		>.pd-info 
			width: 50%


+rwd(750px)
	.modal-close-botton
		display: block
		width: 100%
		height: 60px
		background-color: #31006c
		font-size: 32px
		line-height: 60px
		font-weight: 500
		text-align: center
		color: #bbbbbb
	.modal
		padding: 2% !important
	.modal-dialog
		margin: 0
		border-width:  10px
		height: auto
		.close 
			$close-size: 89px
			width: $close-size 
			height: $close-size
		.modal-body 
			padding: 8%
			display: block
			>.modal-pd-pic
				width: 590px
				height: 590px
			.pd-info
				width: 100%
				height: auto
				margin-top: 29px
				&-brand-name
					font-size: 32px
					line-height: 1
				&-pd-name 
					font-size: 48px
					margin-bottom: 50px
					margin-top: 13px
					
				&-price,
				&-capacity 
					font-size: 32px
					line-height: 1

				&-detail
					margin-top: 18px
					font-size: 32px
					line-height: 1.31
					letter-spacing: 1.6px
				a 
					position: relative
		.vote-btn 
			width: 380px
			height: 80px
			font-size: 32px
			line-height: 80px
			margin-top: 43px
	.expert-comment-box
		margin-top: 153px
		position: relative
		width: 100%
		display: block
		padding: 130px 41px 41px
		height: auto
		>.modal-expert-comment
			margin-top: 10px
			font-size: 32px
			line-height: 1.31
			text-align: justify
		> .modal-expert-pic-box 
			position: absolute
			top: -120px
			left: calc(50% - 102px)
			.pic	
				margin: 0 auto 
				width: 204px
				height: 204px
			span 
				font-size: 25.8px
				font-weight: 300
.popular 
	.modal-dialog
		border-image-source: linear-gradient(335deg, #8a7952 28%, #e4d28a)		
+rwd(750px)
	.popular 
		.modal-close-botton
			background-color: #8a7952
		.modal-content
			box-shadow: none

</style>


// WEBPACK FOOTER //
// Modal.vue?676f9102